import { ERROR_MESSAGES } from '../constants';

export const API_BASE = '/article-evaluation/v1';
export const UNAUTHORIZED_EVENT = 'article-evaluation:unauthorized';

export class ApiError extends Error {
  code: number;
  error: string;
  constructor(code: number, error: string, message: string) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
    this.error = error;
  }
}

export function getDeviceId(): string {
  const key = 'article-evaluation:device-id';
  try {
    const existing = sessionStorage.getItem(key);
    if (existing) return existing;
    const value = crypto.randomUUID();
    sessionStorage.setItem(key, value);
    return value;
  } catch {
    return 'browser-device';
  }
}

interface RequestOptions {
  notifyUnauthorized?: boolean;
}

async function request<T>(
  path: string,
  init: RequestInit = {},
  options: RequestOptions = {}
): Promise<T> {
  let response: Response;
  try {
    response = await fetch(`${API_BASE}${path}`, {
      ...init,
      credentials: 'include',
      signal: init.signal,
      headers: { 'Content-Type': 'application/json', ...(init.headers || {}) }
    });
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') throw error;
    throw new ApiError(0, 'NetworkError', '网络连接失败，请检查网络后重试');
  }
  let payload: { code?: number; message?: string; error?: string; data?: T };
  try {
    payload = await response.json();
  } catch {
    throw new ApiError(response.status, 'InvalidResponse', '服务响应异常，请稍后再试');
  }
  const code = Number(payload.code ?? response.status);
  if (code !== 0) {
    const errorName = payload.error || 'RequestFailed';
    if (
      options.notifyUnauthorized !== false &&
      (code === 401 || errorName === 'ArticleEvaluationUnauthorized')
    ) {
      window.dispatchEvent(new CustomEvent(UNAUTHORIZED_EVENT));
    }
    throw new ApiError(
      code,
      errorName,
      payload.message || ERROR_MESSAGES[errorName] || '操作失败，请稍后再试'
    );
  }
  return payload.data as T;
}

export const api = {
  get: <T>(path: string, signal?: AbortSignal, options?: RequestOptions) =>
    request<T>(path, { method: 'GET', signal }, options),
  post: <T>(path: string, body?: unknown, signal?: AbortSignal, options?: RequestOptions) =>
    request<T>(
      path,
      { method: 'POST', body: body === undefined ? undefined : JSON.stringify(body), signal },
      options
    )
};
